const PACKAGE_SIZES = {
    medium: 'medium',
    small: 'small'
}

const PACKAGE_SIZES_TEXT = {
    medium: 'Mediano',
    small: 'Pequeño'
}

module.exports = { PACKAGE_SIZES, PACKAGE_SIZES_TEXT }